import { createContext, ReactNode, useState } from 'react';
export interface SelectionContextTypes {
    selection: string[];
    isInSelectionMode: boolean;
    isSelectAll: boolean;
    selectAllProducts: (productId: string[]) => void;
    toggleProductSelection: () => void;
    selectSingleProduct: (productId: string) => void;
    cancelSelection: () => void;
}

export const SelectionContext = createContext<SelectionContextTypes>({
    selection: [],
    isInSelectionMode: false,
    isSelectAll: false,
    selectAllProducts: () => {},
    toggleProductSelection: () => {},
    selectSingleProduct: () => {},
    cancelSelection: () => {}
});

interface Props {
    children: ReactNode;
}

export const SelectionContextProvider = ({ children }: Props) => {
    const [selection, setSelection] = useState<string[]>([]);
    const [isInSelectionMode, setIsInSelectionMode] = useState<boolean>(false);
    const [isSelectAll, setIsSelectAll] = useState<boolean>(false);

    const selectAllProducts = (productIds: string[]) => {
        setIsInSelectionMode(true);
        setIsSelectAll(true);
        setSelection(productIds);
    };

    const cancelSelection = () => {
        setIsInSelectionMode(false);
        setIsSelectAll(false);
        setSelection([]);
    };

    const toggleProductSelection = () => {
        if (isInSelectionMode) {
            cancelSelection();
        } else {
            setIsInSelectionMode(true);
        }
    };

    const selectSingleProduct = (productId: string) => {
        if (selection.includes(productId)) {
            if (selection.length === 1) {
                cancelSelection();
            } else {
                setSelection(selection.filter(p => p !== productId));
            }
        } else {
            setSelection([...selection, productId]);
        }
    };

    return (
        <SelectionContext.Provider
            value={{
                selection,
                isInSelectionMode,
                isSelectAll,
                selectAllProducts,
                toggleProductSelection,
                selectSingleProduct,
                cancelSelection
            }}
        >
            {children}
        </SelectionContext.Provider>
    );
};
